import { render, staticRenderFns } from "./MessageDialog.vue?vue&type=template&id=295935f2&scoped=true"
import script from "./MessageDialog.vue?vue&type=script&lang=js"
export * from "./MessageDialog.vue?vue&type=script&lang=js"
import style0 from "./MessageDialog.vue?vue&type=style&index=0&id=295935f2&prod&lang=scss"
import style1 from "./MessageDialog.vue?vue&type=style&index=1&id=295935f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295935f2",
  null
  
)

export default component.exports